export const BLOCKING_PARTIES = [
  { name: "CUSTOMER", label: "customer" },
  { name: "EEZY", label: "eezy" },
  { name: "TALENT", label: "talent" },
];
